const BUNDLE_BUY_BUTTON_CLICK = 'BundleBuyButtonClick';
const BUNDLE_BUY_CTA_CLICK = 'BundleBuyCtaClick';

const BUNDLE_COLLAPSE_FAQ = 'BundleCollapseFaq';

const BUNDLE_FREE_GET_PROFILE = 'BundleFreeGetProfileClick';
const BUNDLE_FREE_HOW_PROFILE = 'BundleFreeHowProfile';

const COMPLEET_HERO_CTA_CLICK = 'CompleteHeroCtaClick';
const COMPLEET_FEATURES_CTA_CLICK = 'CompleteFeaturesCtaClick';
const COMPLEET_FAQ_TOGGLE = 'CompleteFaqToggle';
const COMPLEET_CONTACT_CALL_CLICK = 'CompleteContactCallClick';
const COMPLEET_STICKY_CTA_CLICK = 'CompleteStickyCtaClick';

const SMB_CORE_LANDING_SHOWN = 'SmbCoreSubscriptionLandingShown';
const SMB_CORE_LANDING_NAVIGATE = 'SmbCoreSubscriptionLandingNavigate';
const SMB_CORE_LANDING_SHOWN_CONFIRM = 'SmbCoreSubscriptionLandingShownConfirm';

const PRO_HERO_REGISTRATION_LINK_CLICK = 'ProHeroRegistrationLinkClick';
const PRO_HERO_BENEFITS_CLICK = 'ProHeroBenefitsClick';
const PRO_FEATURES_LINK_CLICK = 'ProFeaturesLinkClick';
const PRO_CONTACT_CHAT_CLICK = 'ProContactChatClick';
const PRO_CONTACT_CALL_CLICK = 'ProContactCallClick';
const PRO_BOTTOMCTA_PRICES_LINK_CLICK = 'ProBottomctaPricesLinkClick';

export {
  COMPLEET_HERO_CTA_CLICK,
  COMPLEET_FEATURES_CTA_CLICK,
  COMPLEET_FAQ_TOGGLE,
  COMPLEET_CONTACT_CALL_CLICK,
  COMPLEET_STICKY_CTA_CLICK,
  SMB_CORE_LANDING_SHOWN,
  SMB_CORE_LANDING_NAVIGATE,
  SMB_CORE_LANDING_SHOWN_CONFIRM,
  BUNDLE_BUY_BUTTON_CLICK,
  BUNDLE_BUY_CTA_CLICK,
  BUNDLE_COLLAPSE_FAQ,
  BUNDLE_FREE_GET_PROFILE,
  BUNDLE_FREE_HOW_PROFILE,
  PRO_HERO_REGISTRATION_LINK_CLICK,
  PRO_HERO_BENEFITS_CLICK,
  PRO_FEATURES_LINK_CLICK,
  PRO_CONTACT_CHAT_CLICK,
  PRO_CONTACT_CALL_CLICK,
  PRO_BOTTOMCTA_PRICES_LINK_CLICK,
};
